import React from "react";
import theme from './theme';
import { ThemeProvider } from '@mui/material/styles';
import './App.css';

import { UserProvider } from "./UserContext";
import Home from "./components/Home";
import { AuthProvider } from "./AuthContext";
import { SnackbarProvider } from "./components/shared/SnackbarContext";
import { OrderEventsProvider } from "./components/shared/OrderEventsContext";
import miaPanzaLogo from './imgs/logo_mp_m.png';
import { LanguageProvider, useLocale } from './i18n/LanguageContext';

function AppShell() {
  const { locale, setLocale } = useLocale();


  const brandRibbonStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 8,
    padding: '4px 12px',
    borderRadius: 999,
  };

  // layout handled via CSS (.App-header grid for md+)

  return (
    <ThemeProvider theme={theme}>
      <div className="App">
        <header className="App-header" data-testid="app-header">
          <div className="header-left" />

          <div className="header-middle">
            <div style={brandRibbonStyle} className="brand-ribbon">
              <img
                src={miaPanzaLogo}
                alt="MiaPanza logo"
                style={{ height: '1.5em', width: 'auto' }}
              />
              <span>
                <span style={{ color: theme.palette.primary.main }}>Mia</span>
                <span style={{ color: theme.palette.secondary.main }}>Panza</span>
              </span>
            </div>

            <div className="locale-controls">
              <button
                type="button"
                data-testid="locale-en-button"
                aria-pressed={locale === 'en'}
                onClick={() => setLocale('en')}
                className={locale === 'en' ? 'locale-button active' : 'locale-button'}
              >
                English
              </button>
              <button
                type="button"
                data-testid="locale-es-button"
                aria-pressed={locale === 'es'}
                onClick={() => setLocale('es')}
                className={locale === 'es' ? 'locale-button active' : 'locale-button'}
              >
                Español
              </button>
            </div>
          </div>

          <div className="header-right" />
          
        </header>

        <UserProvider >
          <AuthProvider>
            <SnackbarProvider>
              <OrderEventsProvider>
                <Home />
              </OrderEventsProvider>
            </SnackbarProvider>
          </AuthProvider>
        </UserProvider>
      </div>
    </ThemeProvider>
  );
}

function App() {
  return (
    <LanguageProvider>
      <AppShell />
    </LanguageProvider>
  );
}
  
export default App;